import { axios } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import type { PaginatedOptions, PaginatedResults } from "@sdk/utils/paginated-results";
import type { iAccountingBulkOperation } from "./accounting-bulk-operation-model";

export class AccountingBulkOperationsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.accountingBulkOperations.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.accountingBulkOperations = {
      configure: (cfg: { basePath?: string; token?: string }) => {
        Object.assign(this.config, cfg);
      },
      query: async (req: {
        query: Record<string, unknown>;
        options?: PaginatedOptions;
      }): Promise<PaginatedResults<iAccountingBulkOperation>> => {
        const results = await axios.post<
          PaginatedResults<iAccountingBulkOperation>
        >(
          this.config.basePath + "/accounting/bulk-operations/query",
          req,
          { headers: { Authorization: this.config.token } }
        );
        return results.data;
      },
      getById: async (id: string): Promise<iAccountingBulkOperation> => {
        const results = await axios.get<iAccountingBulkOperation>(
          this.config.basePath + `/accounting/bulk-operations/${id}`,
          { headers: { Authorization: this.config.token } }
        );
        return results.data;
      },
    };
    this.accountingBulkOperations.configure(config);
  }

  accountingBulkOperations!: {
    configure: (config: { basePath?: string; token?: string }) => void;
    query: (req: {
      query: Record<string, unknown>;
      options?: PaginatedOptions;
    }) => Promise<PaginatedResults<iAccountingBulkOperation>>;
    getById: (id: string) => Promise<iAccountingBulkOperation>;
  };
}

export const accountingBulkOperationsServices =
  new AccountingBulkOperationsServices(SDKConfig);
